import type { StoreItem } from "@editor/items/StoreItem";
import { defineItemMigration } from "@editor/items/itemStoreMigration";

interface NewStakeholder extends StoreItem {
  type: "stakeholder";

  elementIds?: number[];
  targetIds?: number[];
}

export default defineItemMigration<NewStakeholder, LegacyStakeholderItem>(
  (itemStore, oldStakeholder, newStakeholder) => {
    if ("elementIds" in oldStakeholder) {
      newStakeholder.targetIds = oldStakeholder.elementIds;
      delete newStakeholder.elementIds;
    }
  }
);

interface LegacyStakeholderItem extends StoreItem {
  id: number;
  type: "stakeholder";

  title: string;
  description: string;

  elementIds?: number[];
}
